export class DebugEvents {
  public static showDebugPanel = 'showDebugPanel';
}



// WEBPACK FOOTER //
// ./src/events/DebugEvents.ts